import { updateEditorInputFieldMutation } from '@/editor/editor-block-view/api/graphql/editor-view.mutations';
import { UpdateInputFieldRequest } from '@/editor/editor-block-view/api/services/types/requests';
import { apolloClient } from '@signing-page/apollo';

export class EditorViewService {
  static async updateEditorInputField(payload: UpdateInputFieldRequest): Promise<boolean> {
    const result = await apolloClient.mutate({
      mutation: updateEditorInputFieldMutation,
      variables: payload,
    });
    return !!result;
  }
}
